import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { overtime } from "../_constants/actionConstants";
import { actionScripts } from "../_helpers/actionScripts";
import { getUUID } from "../_utils/generalUtils";

const fetchUserOvertimes = (userId, tabId) => dispatch =>
  new Promise(resolve => {
    dispatch({ type: overtime.FETCH_USER_OVERTIMES });
    const apiEndpoint =
      BASE_URL + "/api/Overtime/GetAllForUser/?userId=" + userId;
    axios
      .get(apiEndpoint)
      .then(response => {
        dispatch({
          type: overtime.FETCH_USER_OVERTIMES_FULFILLED,
          tabId,
          overtimeList: response.data.overtimeList
        });
        console.log(overtime.FETCH_USER_OVERTIMES_FULFILLED);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = overtime.FETCH_USER_OVERTIMES_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(overtime.FETCH_USER_OVERTIMES_REJECTED, err.response.data);
      });
  });

const requestOvertime = (otDto, tabId) => dispatch =>
  new Promise(resolve => {
    dispatch({ type: overtime.REQUEST_OVERTIME });
    const apiEndpoint = BASE_URL + "/api/Overtime/RequestOvertime";
    axios
      .post(apiEndpoint, otDto)
      .then(response => {
        dispatch({
          type: overtime.REQUEST_OVERTIME_FULFILLED,
          tabId,
          overtimeList: response.data.overtimeList
        });
        console.log(overtime.REQUEST_OVERTIME_FULFILLED);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = overtime.REQUEST_OVERTIME_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(overtime.REQUEST_OVERTIME_REJECTED, err.response.data);
      });
  });

const overtimeActions = {
  fetchUserOvertimes,
  requestOvertime
};

export default overtimeActions;
